/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import { Fade } from "react-awesome-reveal";

const ContactInfo = () => {
  return (
    <div className="container px-6 py-12 mx-auto bg-gray-50">
      <Fade bottom triggerOnce>
        <h2 className="mb-4 text-4xl font-bold text-center text-gray-800">
          Contact Information
        </h2>
        <p className="mb-12 text-center text-gray-500">
          We are here to assist you. Reach out to us anytime!
        </p>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <svg
                className="w-12 h-12 text-teal-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17.657 16.243l-4.243-4.243m0 0L9.172 7.757M13.414 12l4.243-4.243M13.414 12l-4.243 4.243M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-700">
              Address
            </h3>
            <p className="text-gray-600">
              101 Redwater Road Apt 249, Wake Village TX 75501
            </p>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <svg
                className="w-12 h-12 text-teal-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-700">
              Phone Number
            </h3>
            <p className="text-gray-600">+1 (903) 293-2500</p>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <svg
                className="w-12 h-12 text-teal-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-700">Email</h3>
            <p className="text-gray-600">info@katellaventurecapital.com</p>
          </div>
        </div>
        <div className="flex justify-center mt-8 space-x-6">
          <a href="/" className="text-gray-500 transition hover:text-teal-500">
            <svg
              className="w-8 h-8"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 4.41 2.87 8.14 6.84 9.46-.09-.08-.19-.17-.28-.28-.81-.81-1.51-2.12-1.51-3.49 0-2.15 1.15-3.92 2.87-4.91-.18-.46-.28-.96-.28-1.47 0-1.65 1.34-2.99 2.99-2.99s2.99 1.34 2.99 2.99c0 .51-.1 1.01-.28 1.47 1.72.99 2.87 2.76 2.87 4.91 0 1.37-.7 2.68-1.51 3.49-.09.11-.19.2-.28.28 3.97-1.32 6.84-5.05 6.84-9.46 0-5.5-4.46-9.96-9.96-9.96zm0 18.92c-.92 0-1.81-.14-2.65-.39.46-.61.86-1.28 1.18-2.01.55-1.25.87-2.63.87-4.06 0-.92-.18-1.8-.51-2.62-.33-.82-.81-1.56-1.41-2.16-.6-.6-1.34-1.08-2.16-1.41-.82-.33-1.7-.51-2.62-.51s-1.8.18-2.62.51c-.82.33-1.56.81-2.16 1.41-.6.6-1.08 1.34-1.41 2.16-.33.82-.51 1.7-.51 2.62 0 1.43.32 2.81.87 4.06.32.73.72 1.4 1.18 2.01-.84.25-1.73.39-2.65.39-5.5 0-9.96-4.46-9.96-9.96s4.46-9.96 9.96-9.96 9.96 4.46 9.96 9.96c0 5.5-4.46 9.96-9.96 9.96z" />
            </svg>
          </a>
          <a href="/" className="text-gray-500 transition hover:text-teal-500">
            <svg
              className="w-8 h-8"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M19.54 4.54c-.97-.36-2.02-.6-3.12-.71-.45-.05-.81.28-.86.73-.05.46.28.86.73.91 1.03.11 1.99.34 2.91.67.45.16.92-.07 1.08-.52.16-.45-.07-.92-.52-1.08zm-6.54-.54c0-.55-.45-1-1-1s-1 .45-1 1v1h2v-1zm8.5 5c0-.55-.45-1-1-1h-1v2h1c.55 0 1-.45 1-1zm-18 0c0 .55.45 1 1 1h1v-2h-1c-.55 0-1 .45-1 1zm8.5 12c0 .55.45 1 1 1s1-.45 1-1v-1h-2v1zm-6.54-5.54c-.16.45.07.92.52 1.08.92.33 1.88.56 2.91.67.45.05.81-.28.86-.73.05-.46-.28-.86-.73-.91-1.1-.11-2.15-.35-3.12-.71-.45-.16-.92.07-1.08.52zm-5.46-5.46c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6zm18 0c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" />
            </svg>
          </a>
          <a href="/" className="text-gray-500 transition hover:text-teal-500">
            <svg
              className="w-8 h-8"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05-.78-.83-1.89-1.35-3.12-1.35-2.36 0-4.27 1.91-4.27 4.27 0 .33.04.66.11.97-3.55-.18-6.7-1.88-8.81-4.46-.37.63-.58 1.36-.58 2.14 0 1.48.75 2.78 1.89 3.54-.69-.02-1.34-.21-1.91-.52v.05c0 2.06 1.47 3.78 3.42 4.17-.36.1-.73.15-1.12.15-.27 0-.54-.03-.8-.08.54 1.69 2.11 2.92 3.97 2.96-1.46 1.14-3.29 1.82-5.28 1.82-.34 0-.68-.02-1.01-.06 1.87 1.2 4.09 1.9 6.48 1.9 7.78 0 12.03-6.44 12.03-12.03 0-.18 0-.36-.01-.54.83-.6 1.55-1.34 2.12-2.19z" />
            </svg>
          </a>
        </div>
      </Fade>
    </div>
  );
};

export default ContactInfo;
